var jquery = require("/js/lib/jquery");
import 'babel-polyfill';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import Dialog from './dialog';
import debounce from './debounce';

window.$ = window.jQuery = jquery;

import cookie from './cookie';
import config from './clientServerConfig.json';
import wsCall, { wsCallAsync } from './wsCall';
import appData, { STATE } from './appData';

function App() {
  var self = this;

}

App.prototype.init = async function() {
  var self = this;

  appData.init({
    watch: {
    },
    computed: {
    },
    methods: {
      selectCategory: function (item) {
        this.saved.math.category = item;
        this.save();
        this.$forceUpdate();
        if (window.gtag) window.gtag('event', 'MathSelectCategory');
      },
      restart: function () {
        if (window.gtag) window.gtag('event', 'MathStart');
      },
      start: function () {
        if (window.gtag) window.gtag('event', 'MathRestart');
      },
    }
  });

  $(document).on('click', '.dropdown', function(e) {
    let hasClass = $(e.currentTarget).children('.dropdownContent').hasClass('dropdownShow');
    $('.dropdownContent').removeClass('dropdownShow');
    if (!hasClass) {
      $(e.currentTarget).children('.dropdownContent').addClass('dropdownShow');
    }
  });

  $('#logo').on('click', function() {
    document.location.href = '/';
  });

};

var app = new App();

app.init();


export default app;